import script from "./ChatReportsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatReportsList.vue?vue&type=script&setup=true&lang=js"

import "./ChatReportsList.vue?vue&type=style&index=0&id=ef9dd7de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef9dd7de"]])

export default __exports__